import { render, staticRenderFns } from "./AdvisorClientView.vue?vue&type=template&id=5fc5a0a1&scoped=true&"
import script from "./AdvisorClientView.vue?vue&type=script&lang=ts&"
export * from "./AdvisorClientView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5a0a1",
  null
  
)

export default component.exports